/**
 * RowDetailTabs — CHI TIẾT (chỉ đọc) của dòng đang chọn, mỗi lưới con là một tab.
 *
 * Đặt ở nửa dưới của màn hình danh sách chia đôi. Chỉ ĐỌC, đúng như `InputBaseDetail` của bộ cũ: xem
 * nhanh chi tiết dòng đang chọn, muốn sửa thì mở form. Nhờ chỉ-đọc nên `ObjectArrayControl` không mount
 * control nào (chỉ render chữ) — cuộn qua danh sách không tốn kém.
 */
import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import ObjectArrayControl from './ObjectArrayControl';
import { detailTabFields } from './masterDetailSplit';

const NOOP = () => {};
const NO_ERRORS = {};

export default function RowDetailTabs({ row, fields, isMobile }) {
  const [tabIndex, setTabIndex] = useState(0);

  // KHÔNG lọc theo `hideInView` (kể cả dạng script): cờ đó chỉ dành cho trang xem, không áp cho danh
  // sách — xem masterDetailSplit.detailTabFields.
  const tabs = useMemo(() => detailTabFields(fields), [fields]);

  useEffect(() => {
    if (tabIndex > tabs.length - 1) setTabIndex(0);
  }, [tabs.length, tabIndex]);

  if (!row) {
    return (
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
        <Typography variant="body2" color="text.secondary">Chọn một dòng ở trên để xem chi tiết.</Typography>
      </Box>
    );
  }
  if (tabs.length === 0) {
    return (
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
        <Typography variant="body2" color="text.secondary">Dòng này không có phần chi tiết.</Typography>
      </Box>
    );
  }

  const active = tabs[Math.min(tabIndex, tabs.length - 1)];

  return (
    <Box sx={{ flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column', bgcolor: 'background.paper' }}>
      {tabs.length > 1 && (
        <Tabs
          value={Math.min(tabIndex, tabs.length - 1)}
          onChange={(e, v) => setTabIndex(v)}
          variant="scrollable" scrollButtons="auto"
          sx={{ flexShrink: 0, minHeight: 38, borderBottom: '1px solid', borderColor: 'divider', '& .MuiTab-root': { minHeight: 38, textTransform: 'none' } }}
        >
          {tabs.map((f) => <Tab key={f.field} label={f.label || f.field} />)}
        </Tabs>
      )}

      <Box sx={{ flexGrow: 1, minHeight: 0, p: 1, display: 'flex', flexDirection: 'column' }}>
        <ObjectArrayControl
          key={`${active.field}_${row._id || row.id || ''}`}
          field={active}
          value={row[active.field]}
          onChange={NOOP}
          formErrors={NO_ERRORS}
          isReadOnly
          isMobile={isMobile}
          masterData={row}
          fillHeight
        />
      </Box>
    </Box>
  );
}
